import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "logo" }

import {computed, h} from "vue"
import {useRoute} from "vue-router";
import {LogoutOutlined, SaveOutlined, SendOutlined} from "@ant-design/icons-vue";
import {AEditor} from "@/views/editor/service/editor";


export default /*@__PURE__*/_defineComponent({
  __name: 'EditorHeader',
  setup(__props) {


const editor = useRoute().meta.editor as AEditor;

const branches = computed(() => {
  const arr = [] as unknown[]
  editor.meta.branch_ids.forEach((branch_id: string) => {
    editor.userAgent.meta.brands.forEach(b => {
      const br = b.branches.find(i => i.branch_id === branch_id)
      if (br) arr.push({label: b.name + br.name, value: br.branch_id})
    })
  })
  return arr
})


return (_ctx: any,_cache: any) => {
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_flex = _resolveComponent("a-flex")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createBlock(_component_a_flex, {
    justify: "space-between",
    align: "center",
    style: {"width":"100%"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_flex, {
        align: "center",
        gap: "small"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_a_avatar, {
              src: "/img/logo.svg",
              shape: "square",
              size: "large"
            }),
            _createVNode(_component_a_flex, {
              align: "center",
              gap: "28"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_typography_text, null, {
                  default: _withCtx(() => _cache[5] || (_cache[5] = [
                    _createTextVNode("管店宝拓客")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_a_divider, { type: "vertical" }),
          _createVNode(_component_a_typography_text, {
            strong: "",
            style: {"font-size":"16px"}
          }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [
              _createTextVNode("活动编辑器")
            ])),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_a_flex, { justify: "center" }, {
        default: _withCtx(() => [
          (_unref(editor).active.preview.branch_id)
            ? (_openBlock(), _createBlock(_component_a_select, {
                key: 0,
                style: {"width":"100%","min-width":"300px"},
                size: "large",
                "not-found-content": "暂无可选的品牌/分支",
                options: branches.value,
                value: _unref(editor).active.preview.branch_id,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(editor).active.preview.branch_id) = $event)),
                onChange: _cache[1] || (_cache[1] = ($event: any) => (_unref(editor).refresh()))
              }, null, 8, ["options", "value"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_a_flex, {
        style: {"padding-right":"16px"},
        gap: "middle"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_button, {
            danger: "",
            size: "large",
            icon: h(_unref(LogoutOutlined)),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/activities'))),
            loading: _unref(editor).active.status.loading
          }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [
              _createTextVNode(" 退出 ")
            ])),
            _: 1
          }, 8, ["icon", "loading"]),
          (!_unref(editor).meta.publish_at && _unref(editor).meta.activity_id)
            ? (_openBlock(), _createBlock(_component_a_button, {
                key: 0,
                size: "large",
                icon: h(_unref(SaveOutlined)),
                type: "default",
                loading: _unref(editor).active.status.loading,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(editor).save()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(editor).active.status.lastSaveTS) + " 保存 ", 1)
                ]),
                _: 1
              }, 8, ["icon", "loading"]))
            : _createCommentVNode("", true),
          (!_unref(editor).meta.publish_at)
            ? (_openBlock(), _createBlock(_component_a_button, {
                key: 1,
                size: "large",
                icon: h(_unref(SendOutlined)),
                type: "primary",
                loading: _unref(editor).active.status.loading,
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(editor).publish()))
              }, {
                default: _withCtx(() => _cache[8] || (_cache[8] = [
                  _createTextVNode("发布 ")
                ])),
                _: 1
              }, 8, ["icon", "loading"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})